
<div class="main-container">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="water-pin-close-container">
        <div class="header-container-new-water-pin">
            <span><img src="../../assets/icons/water_pin.png" alt="New Pin Icon" class="new-water-pin-header-icon"> </span>
            <h1 mat-dialog-title  class="new-water-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.WATER-TITLE' | translate }}</h1>
        </div>
    </div>

    <div class="water-pin-info-container">

        <div class="water-pin-container">
            <div class="water-pin-headers">
                <p class="water-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.DATE-TIME' | translate }}:</p>
                <p class="water-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LATITUDE' | translate }}:</p>
                <p class="water-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LONGITUDE' | translate }}:</p>
                <p class="water-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FARM' | translate }}:</p>
                <p class="water-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FIELD' | translate }}:</p>
                <p class="water-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.CREATED-BY' | translate }}:</p>
            </div>

        </div>

        <div class="water-pin-container">
            <ng-container>
                <p class="water-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
                <p class="water-pin-info-text">{{pinObj.lat}}</p>
                <p class="water-pin-info-text">{{pinObj.lng}}</p>
                <p class="water-pin-info-text">{{pinObj.farm}}</p>
                <p class="water-pin-info-text">{{pinObj.field}}</p>
                <p class="water-pin-info-text">{{pinObj.creatingUser}}</p>
            </ng-container>

        </div>
    </div>

    <form [formGroup]="updatePinForm">
        <mat-form-field class="water-pin-input" appearance="outline">
            <mat-label>{{'NEW-SAVE-PIN-DIALOG.PIN-NAME' | translate }}</mat-label>
            <input matInput formControlName="pinDescription">
            <mat-error *ngIf="updatePinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error>
        </mat-form-field>

    <div class="water-pin-btn-container">
        <div class="water-pin-delete-btn-container">
            <button class="delete-water-pin-btn" mat-flat-button type="button" (click)="openDeletePinDialog()">
                <div class="water-pin-btn-content">
                    <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-water-pin-btn-icon">
                    <span><p class="water-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.DELETE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

        <!-- <div class="water-pin-open-water-btn-container">
            <button class="open-water-pin-btn" mat-flat-button type="button" (click)="openConvertPinDialog()">
                <div class="water-pin-btn-content">
                    <span><p class="water-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.COVERT-PIN' | translate }}</p></span>
                </div>
            </button>
        </div> -->

        <div class="water-pin-update-btn-container">
            <button class="update-water-pin-btn" mat-flat-button type="button" (click)="updatePin()">
                <div class="water-pin-btn-content">
                    <span><p class="water-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.UPDATE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

    </div>

</form>

</div>


